module.exports = __webpack_public_path__ + "static/media/picture6.6fab3587.png";